import { SortBy } from 'react-instantsearch-dom'
import styles from './search-sort.module.scss'
import { useTranslation } from 'next-i18next'

export function SearchSort({ locale, indexName }: any) {
  const { t: translate } = useTranslation('sort')
  return (
    <div className={styles.searchSort}>
      <label htmlFor="plp_sort">{translate('sort-sort-by')} | </label>
      <SortBy
        className={styles.searchSortDrop}
        id="plp_sort"
        items={[
          {
            label: translate('sort-relevance'),
            value: `${indexName}/sort/_eval(is_in_stock:true):desc,sales_count:desc,_text_match:desc`,
          },
          {
            label: translate('sort-price-asc'),
            value: `${indexName}/sort/special_price:asc`,
          },
          {
            label: translate('sort-price-desc'),
            value: `${indexName}/sort/special_price:desc`,
          },
          {
            label: translate('sort-ships-in-asc'),
            value: `${indexName}/sort/ships_in_days:asc`,
          },
          {
            label: translate('sort-ships-in-desc'),
            value: `${indexName}/sort/ships_in_days:desc`,
          },
          {
            label: translate('sort-most-popular'),
            value: `${indexName}/sort/sales_count:desc`,
          },
          {
            label: translate('sort-rating-desc'),
            value: `${indexName}/sort/rating_avg:desc`,
          },
          {
            label: translate('sort-name-asc'),
            value: `${indexName}/sort/brand:asc, name:asc`,
          },
          {
            label: translate('sort-name-desc'),
            value: `${indexName}/sort/brand:desc, name:desc`,
          },
        ]}
        defaultRefinement={`${indexName}/sort/_eval(is_in_stock:true):desc,sales_count:desc,_text_match:desc`}
      />
    </div>
  )
}
